import { ProductBuilderMachineContext } from '../types';
import { getBaseProductType } from './getBaseProductType';
import { getCurtainLineItems } from './getCurtainLineItems';
import { getHoneycombLineItems } from './getHoneycombLineItemProperties';
import { getRollerblindLineItems } from './getRollerblindLineItemProperties';
import { getRomanLineItems } from './getRomanLineItemProperties';
import { getShutterLineItems } from './getShutterLineItemProperties';
import { getVenetianLineItems } from './getVenetianLineItemProperties';

export const getLineItems = (context: ProductBuilderMachineContext) => {
  const productType = getBaseProductType(context);
  const lineItemProperties =
    productType === 'Honeycomb'
      ? getHoneycombLineItems(context)
      : productType === 'Curtain'
      ? getCurtainLineItems(context)
      : productType === 'Roller Blind'
      ? getRollerblindLineItems(context)
      : productType === 'Roman Blinds'
      ? getRomanLineItems(context)
      : productType === 'Venetian'
      ? getVenetianLineItems(context)
      : productType === 'Shutter'
      ? getShutterLineItems(context)
      : '';
  return lineItemProperties;
};
